export default "__VITE_ASSET__CBg9rQNj__"